import { defineStore } from "pinia";

export const useAppStore = defineStore("app", {
  state: () => ({
    lightbox: {
      open: false,
      embedUrl: "",
    },
  }),
  actions: {
    closeLightbox() {
      this.lightbox.open = false;
    },
  },
});
